// LocaleDateFormatter/en.ts
import type { Translations } from './translationsTypes';

const en: Translations = {
    Hour: 'h',
    Min: 'mm',
    Day: 'dd',
    Month: 'MMMM',
    Extend: 'a',
    HourMin: 'hh:mm a',
    HourMinSecond: 'hh:mm:ss a',
    HourMinFull: 'hh:mm:ss a ZZZZ',
    Trunc: 'MMM d, yyyy',
    Date: 'MMMM d, yyyy',
    Classic: 'MM-dd-yyyy',
    DateGlobal: 'dd-MM-yyyy',
    TimeSpecial: '{HOUR}:{MIN} {EXTEND}',
    UTC: 'ZZZZ',
    AdfDayMonth: '{MONTH} {DAY}',
    AdfTimeDate: 'at {TIME} on {DATE}',
    AdfDateTime: 'on {DATE} at {TIME}',
    AdfTime: '{TIME} on {DATE}',
    AdfDate: '{DATE} at {TIME}',
};

export default en;
